import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import makeAnimated from 'react-select/lib/animated';
import update from 'immutability-helper';
import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';
import Logged from '../Logged/Logged';
import { Permissions } from '../../Utils/Permissions';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';

const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            fontWeight: data.pai ? 'bold' : 'normal',
            textTransform: data.pai ? 'uppercase' : 'capitalize',
            textIndent: data.pai ? 0 : 50,
            // paddingLeft: data.pai ? styles.paddingLeft : 30,
            // paddingLeft: data.pai ? 0 : 30,
            display: 'list-item',
            listStyleType: 'square',
        };
    },
};

class ListaAtendimentos extends Component {

    constructor() {
        super();

        this.toggleFilters = this.toggleFilters.bind(this);
        this.getAtendimentos = this.getAtendimentos.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.carregaCategorias = this.carregaCategorias.bind(this);
        this.carregaAtendentes = this.carregaAtendentes.bind(this);
        this.permissaoAtendimento = this.permissaoAtendimento.bind(this);

        this._atendimentoFocusChange = this.handleFocusChange('atendimento').bind(this);
        this._atendimentoDatesChange = this.handleDatesChange('atendimento').bind(this);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.Configurations = new Configurations();
        this.logged = new Logged();

        this.atendimentoStatusOptions = [
            { label: "Iniciado", value: 1 },
            { label: "Pausado", value: 2 },
            { label: "Em Atendimento", value: 3 },
            { label: "Finalizado", value: 4 },
        ]

        this.prioridadesOptions = [
            { label: "Baixa", value: 1 },
            { label: "Média", value: 2 },
            { label: "Alta", value: 3 },
        ]

        this.state = {
            openFilters: true,
            filters: {
                order: { label: "dtCriacaoAtendimento", ascDesc: "desc" },
                atendimento: {},
                listaCategorias: [],
                listaPrioridades: [],
                listaStatusAtendimento: [],
                listaAtendentes: []
            },
            codMembroBusca: '',
            buscaRealizada: false,
            alertaBuscaMembro: false,
            loading: true,
            hasError: false,
            errorMessage: '',
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.columns = [
            {
                Header: 'idAtend',
                accessor: 'idAtendimento',
                className: 'text-center pointer',
                width: 80
            },
            {
                Header: 'Solicitante',
                className: 'pointer',
                accessor: 'nomeMembro',
                width: 220,
                Cell: row => {
                    const _idAtend = row.original.idSolicitante,
                        _class = _idAtend ? '' : 'text-danger font-italic',
                        _value = _idAtend ? row.value : 'Atendimento sem membro solicitante';
                    return <span className={_class}>{_value}</span>
                }
            },
            {
                Header: 'Cód. Mem.',
                accessor: 'codMembro',
                className: 'text-center pointer',
                width: 80,
                Cell: row => {
                    return <span>{row.value ? row.value : '-'}</span>
                }
            },
            {
                Header: () => (<span>Status <i className="fas fa-sort"></i></span>),
                accessor: 'nomeStatusAtendimento',
                className: 'pointer text-center',
                width: 100,
                Cell: row => {
                    const _idStatus = row.original.idStatusAtendimento;
                    return <span className={`badge badge-${this.tipoBadgeAtendimento(_idStatus)}`}>{row.value}</span>
                }

            },
            {
                Header: () => (<span>Prioridade <i className="fas fa-sort"></i></span>),
                accessor: 'nomePrioridade',
                className: 'pointer text-center',
                width: 90,
                Cell: row => {
                    const _idStatus = row.original.idPrioridadeAtendimento;
                    return <span className={`badge badge-${this.tipoBadgePrioridade(_idStatus)}`}>{row.value}</span>
                }
            },
            {
                Header: () => (<span>Dt. Criação <i className="fas fa-sort"></i></span>),
                accessor: 'dtCriacaoAtendimento',
                className: 'pointer text-center',
                width: 120,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: 'Dt. Modificação',
                accessor: 'dtModificacaoAtendimento',
                className: 'pointer text-center',
                width: 120,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: 'Resp.',
                accessor: 'nomeUserFukyo',
                className: 'text-center pointer',
                width: 120,
            },
            {
                Header: 'Categorias',
                className: 'text-center pointer',
                Cell: row => {
                    const _arrayCat = this.state.listaAtendimentos[row.index].listaCategorias.map(cat => { return cat.nomeCategoria });
                    // return _arrayCat.join(", ")
                    return _arrayCat.map((nomeCat, idx) => <span key={`cat-${idx}`} className="badge badge-secondary mx-1">{nomeCat}</span>)
                }
            },
        ];

    }

    componentDidMount() {
        this.carregaCategorias();
        this.carregaAtendentes();
    }

    carregaCategorias() {
        this.setState({ loading: true })
        axios.get(this.Configurations.apiBasePath + `/atendimentos/categorias`).then(response => {
            let _arrayFinalCategorias = [];
            response.data.listaCategorias.forEach(item => {
                if (item.subCategorias && item.subCategorias.length > 0) {
                    _arrayFinalCategorias.push(
                        {
                            label: item.nome, value: item.idCategoria, pai: true,
                        });
                    _arrayFinalCategorias.push(
                        {
                            label: `Subcategorias de ${item.nome}`,
                            options: item.subCategorias.map(sub => ({ label: `${sub.nomeCategoria}`, value: sub.idCategoria }))
                        });
                }
            })
            this.setState({ categoriasOptions: _arrayFinalCategorias })
        }).catch(this.handleError).finally(() => this.setState({ loading: false }));
    }

    carregaAtendentes() {
        this.setState({ loading: true })
        axios.get(this.Configurations.apiBasePath + `/usuarios/lista`).then(response => {
            this.setState({ atendentesOptions: response.data.usuarios.filter(user => this.permissaoAtendimento(user)).map(item => ({ label: item.nome, value: item.id })) })
        }).catch(this.handleError).finally(() => this.setState({ loading: false }));
    }

    permissaoAtendimento(_user) {
        const _arrPerm = _user.permissions,
            _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat(),
            _permAdmin = ["admin"].some(r => _paginas.indexOf(r) >= 0),
            _permAtendimento = ["atendimento"].some(r => _paginas.indexOf(r) >= 0);
        return _permAdmin || _permAtendimento;
    }

    tipoBadgeAtendimento(status) {
        switch (status) {
            case 2:
                return "warning";
            case 3:
                return "info";
            case 4:
                return "success";
            default: //
                return "primary";
        }
    }

    tipoBadgePrioridade(status) {
        switch (status) {
            case 1:
                return "secondary";
            case 2:
                return "warning";
            default: // 3
                return "danger";
        }
    }

    handleSelectChange(e, o) {
        const _name = o.name;
        let _list = this.state.filters[_name];
        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                //-- do
                break;
            case "clear":
                const _filters = this.state.filters;
                _filters[_name] = [];
                this.setState({
                    filters: _filters
                });
                return o;
            default:
                _list.push(o.option);
                break;
        }

        const _filters = update(this.state.filters, { $merge: { [_name]: _list } });
        this.setState({ _filters });

        return o;
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    getAtendimentos(o) {
        // console.log("o: ", o)
        this.setState({ loading: true });

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        if (this.state.filters.listaAtendentes.length > 0) {
            _params.push(`listaUserFukyo=${this.state.filters.listaAtendentes.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.listaStatusAtendimento.length > 0) {
            _params.push(`listaStatusAtendimento=${this.state.filters.listaStatusAtendimento.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.listaPrioridades.length > 0) {
            _params.push(`listaPrioridadeAtendimento=${this.state.filters.listaPrioridades.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.listaCategorias.length > 0) {
            _params.push(`listaCategoria=${this.state.filters.listaCategorias.map(item => item.value).join(',')}`);
        }

        // if (this.state.filters.atendimento.startDate && this.state.filters.atendimento.endDate) {
        //     _params.push(`dtInicioCriacao=${moment(this.state.filters.atendimento.startDate).format()}`);
        //     _params.push(`dtFimCriacao=${moment(this.state.filters.atendimento.endDate).format()}`);
        // }
        if (this.state.filters.atendimento.startDate) {
            _params.push(`dtCriacaoInicio=${moment(this.state.filters.atendimento.startDate).format("DD/MM/YYYY")}`);
        }
        if (this.state.filters.atendimento.endDate) {
            _params.push(`dtCriacaoFim=${moment(this.state.filters.atendimento.endDate).format("DD/MM/YYYY")}`);
        }

        if (this.state.filters.order.label) {
            _params.push(`orderBy=${this.state.filters.order.label}&ascDesc=${this.state.filters.order.ascDesc}`);
        }

        const _atendimentos = axios.get(this.Configurations.apiBasePath + `/atendimentos?${_params.join('&')}`);

        const _parametros = _params.join('&');

        _atendimentos.then(response => {
            this.setState({
                listaAtendimentos: response.data.atendimentos,
                pages: response.data.paginacao.totalPaginas,
                parametros: _parametros
            });
        }).catch(err => {
            if (err.response.status === 404) this.setState({
                listaAtendimentos: [],
                pages: 1,
                parametros: _parametros
            })
        }).finally(() => this.setState({ loading: false }));
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    refreshTable(o) {
        this.getAtendimentos(o);
    }

    _outsideRange(day) {
        return day.format() > moment().format();
    }

    filterSearch(e) {
        e.preventDefault();
        // this.salvaParametros();
        this.getAtendimentos({});
    }

    ordernaDados(_accessor) {
        const _ascDesc = this.state.filters.order.ascDesc,
            _isDesc = _ascDesc ? _ascDesc.toLowerCase() === "desc" : true,
            _newAscDesc = _isDesc ? 'asc' : 'desc';
        let _label, _valido = false;

        switch (_accessor) {
            case "nomePrioridade":
                _label = "idPrioridadeAtendimento";
                _valido = true;
                break;
            case "nomeStatusAtendimento":
                _label = "idStatusAtendimento";
                _valido = true;
                break;
            case "dtCriacaoAtendimento":
                _label = "dtCriacaoAtendimento";
                _valido = true;
                break;
            default:
                _label = null;
                _valido = false;
                break;
        }
        if (_valido)
            this.setState({ filters: update(this.state.filters, { order: { $set: { label: _label, ascDesc: _newAscDesc } } }) }, () => {
                this.getAtendimentos({});
            })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {
        return (
            <div className="atendimento-list">
                <div className="row">
                    <div className="col-9">
                        <h2 className="title-1">Lista de Atendimentos</h2>
                    </div>
                    <div className="col-3 text-right">
                        <button onClick={() => this.props.history.push("detalhes/novo-atendimento")} className="btn btn-outline-info">novo atendimento</button>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-2" id="headingOne">
                                <div className="col-12">
                                    <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                        <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                        Filtros
                                    </button>
                                </div>
                            </div>
                            <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                                {this.state.loading ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                        <form onSubmit={this.filterSearch} noValidate>
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="dpStartDate">Período de Criação</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.atendimento.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.atendimento.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._atendimentoDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.atendimento.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._atendimentoFocusChange}
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="dpPayStartDate">Período de Finalização</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.payment.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpPayStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.payment.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpPayEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._paymentDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.payment.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._paymentFocusChange} // PropTypes.func.isRequired,
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusAtendimento">Status Atendimento</label>
                                                        <Select
                                                            id="ddlStatusAtendimento"
                                                            placeholder="Selecione um ou mais status"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaStatusAtendimento}
                                                            isMulti
                                                            name="listaStatusAtendimento"
                                                            onChange={this.handleSelectChange}
                                                            options={this.atendimentoStatusOptions}

                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlCategorias">Categorias</label>
                                                        <Select
                                                            id="ddlCategorias"
                                                            placeholder="Selecione uma ou mais categorias"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            isMulti
                                                            defaultValue={this.state.filters.listaCategorias}
                                                            options={this.state.categoriasOptions}
                                                            onChange={this.handleSelectChange}
                                                            name="listaCategorias"
                                                            styles={colourStyles}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusPagamento">Prioridades</label>
                                                        <Select
                                                            id="ddlPrioridades"
                                                            placeholder="Selecione uma ou mais prioridades"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaPrioridades}
                                                            isMulti
                                                            name="listaPrioridades"
                                                            onChange={this.handleSelectChange}
                                                            options={this.prioridadesOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusPagamento">Atendente</label>
                                                        <Select
                                                            id="ddlAtendentes"
                                                            placeholder="Selecione um ou mais atendentes"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaAtendentes}
                                                            isMulti
                                                            name="listaAtendentes"
                                                            onChange={this.handleSelectChange}
                                                            options={this.state.atendentesOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 text-right">
                                                    <button className="btn btn-primary">Buscar</button>
                                                </div>
                                            </div>
                                        </form>

                                    )}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.listaAtendimentos}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight table-atendimento"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próxima'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum atendimento encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    getTheadThProps={(state, rowInfo, column, instance) => ({
                                        onClick: () => {
                                            this.ordernaDados(column.id);
                                        },
                                    })}
                                    getTrProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                this.props.history.push({ pathname: `/atendimentos/detalhes/${rowInfo.original.idAtendimento}` })
                                            }
                                        }
                                    }}

                                />

                            </div>
                        </div>
                    </div>
                </div>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={false}
                />
            </div>
        )
    }
}

export default ListaAtendimentos;